<!--
Author: TangChen
Date: 2018-09-05
Desc: 登录页面组件，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-register bizcomp ' + className">
        <el-row class="register">
            <el-col :span="20" :offset="2">
                <el-form
                    ref="ruleForm"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="300px"
                    class="demo-ruleForm"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <el-form-item class="mobile-row" label="手机号码:" prop="mobile">
                        <el-row>
                            <el-col>
                                <el-select
                                    v-model="ruleForm.country"
                                    :disabled="true"
                                    class="select"
                                    placeholder="请选择国家码"
                                >
                                    <el-option
                                        v-for="item in countrycode"
                                        :key="item.subitem"
                                        :label="item.subitemname + ' ' + item.subitem"
                                        :value="item.subitem"
                                        :disabled="true"
                                    />
                                </el-select>
                                <el-input
                                    v-model.trim="ruleForm.mobile"
                                    style="margin-left: 10px; width: 260px"
                                    placeholder="请输入手机号码"
                                    :maxlength="11"
                                />
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="短信验证码:" prop="verifyCode">
                        <el-input
                            v-model.trim="ruleForm.verifyCode"
                            placeholder="请输入验证码"
                            :maxlength="6"
                        >
                            <span
                                slot="suffix"
                                :class="time > 0 ? 'get-verify-disabled' : 'get-verify'"
                                v-on:click="mobileCheck"
                            >
                                {{ btnMsg }}
                            </span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="设置密码:" prop="pwd">
                        <el-input
                            v-model.trim="ruleForm.pwd"
                            :type="pwdType"
                            placeholder="请输入登录密码"
                            :maxlength="16"
                        >
                            <i
                                slot="suffix"
                                aria-hidden="true"
                                :class="iconCla"
                                v-on:click="pwdTypeChange"
                            />
                        </el-input>
                    </el-form-item>
                    <el-form-item label="确认密码:" prop="confirmPwd">
                        <el-input
                            v-model.trim="ruleForm.confirmPwd"
                            :type="pwdType"
                            placeholder="再次确认密码"
                            :maxlength="16"
                        >
                            <i
                                slot="suffix"
                                aria-hidden="true"
                                :class="iconCla"
                                v-on:click="pwdTypeChange"
                            />
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="protocol.length > 0" class="protocol">
                        <div class="privacy-agreement">
                            <el-checkbox v-model="checkbox" size="mini"></el-checkbox>
                            <span class="grey">同意</span>
                            <span v-for="item in protocol" :key="item.id" class="red">
                                <a
                                    v-if="item.opentype === '1'"
                                    class="red"
                                    :href="$util.imgSrc({ fileCode: item.fileid })"
                                    target="_blank"
                                >
                                    《{{ item.title }}》
                                </a>
                                <span v-else v-on:click="argRead(item)">《{{ item.title }}》</span>
                            </span>
                        </div>
                    </el-form-item>
                    <el-form-item class="btn-center">
                        <el-button
                            class="dc-cancel-btn"
                            v-on:click="$router.push({ name: 'bindnewacct' })"
                        >
                            暂不注册 直接开户
                        </el-button>
                        <el-button
                            type="primary"
                            class="medium"
                            :disabled="
                                !locked ||
                                !ruleForm.mobile ||
                                !ruleForm.verifyCode ||
                                !ruleForm.pwd ||
                                !ruleForm.confirmPwd ||
                                (protocol.length > 0 && !checkbox)
                            "
                            v-on:click="submitForm('ruleForm', true)"
                        >
                            提交注册
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <my-dialog
            class="register-success"
            title="完成注册提示"
            :visible.sync="registerVisible"
            width="700px"
            :dialog-close="checkDialogClose"
        >
            <div class="register-msg">
                <img src="@/assets/img/success.png" alt="" />
                <p class="msg1">
                    恭喜您！成功注册{{ $cache.getCompanyInfoParam("10101001") }}网上交易账户
                </p>
                <p class="red">立即绑定银行卡进行实名认证，开启购基之旅吧！</p>
            </div>
            <div class="dialog-footer align-c">
                <el-button class="fund-list" type="primary" v-on:click="$router.replace('/fund')">
                    浏览基金产品
                </el-button>
                <el-button
                    class="open-acct"
                    type="primary"
                    v-on:click="$router.push({ name: 'bindnewacct' })"
                >
                    实名认证
                    <img src="@/assets/img/right-arrow.png" alt="" />
                </el-button>
            </div>
        </my-dialog>
        <img-code
            :dialog-visible="dialogVisible"
            :biztype="$const.IMG_BIZTYPE.REGISTER"
            v-on:verify-in="getVerifyCode"
        />
        <my-dialog
            :title="agrData.title"
            :visible.sync="agrVisible"
            :dialog-close="agrVisibleHdie"
            width="800px"
        >
            <div class="protocol-detail" v-html="agrData.content"></div>
            <div class="align-c">
                <el-button type="primary" style="width: 180px" v-on:click="agrVisible = false">
                    确定
                </el-button>
            </div>
        </my-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import imgCode from "@/components/layout/imgCode.vue";
import myDialog from "@/components/layout/myDialog.vue";
import userApi from "@/api/user";
import conf from "@/config/index";
export default {
    name: "RegisterInfo",
    components: {
        imgCode,
        myDialog
    },
    mixins: [mixin],
    data() {
        return {
            pwdType: "password", // 密码输入框类型
            dialogVisible: false, // 是否显示图片验证码框
            time: 0,
            protocol: [],
            agrType: "l", // 协议类型，注册协议
            agrData: {},
            agrVisible: false,
            ruleForm: {
                mobile: "",
                verifyCode: "",
                pwd: "",
                confirmPwd: "",
                type: "",
                country: "中国+86"
            },
            others: [],
            btnMsg: "获取验证码",
            locked: false, // 是否已发送验证码
            iconCla: "fa fa-eye-slash", // 密码输入框图标
            rules: {
                mobile: [
                    { message: "请输入手机号码", trigger: "blur" },
                    { validator: this.validateMobile, trigger: "blur" }
                ],
                verifyCode: [{ validator: this.$util.validateVerifyCode, trigger: "blur" }],
                pwd: [
                    { validator: this.$util.validatePwd, trigger: "blur" },
                    { validator: this.confirm, trigger: "blur" }
                ],
                confirmPwd: [
                    { validator: this.$util.validatePwd, trigger: "blur" },
                    { validator: this.confirm, trigger: "blur" }
                ]
            },
            countrycode: [],
            checkbox: false, // 阅读确认
            registerVisible: false
        };
    },
    mounted() {
        this.$util.initPwdCheckText();
        this.countrycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.getAgreement();
    },
    methods: {
        /* 获取图形验证码值 */
        async getVerifyCode(val) {
            this.dialogVisible = false;
            if (!val) return;
            const res = await userApi.sendSms({
                mobileno: this.ruleForm.mobile,
                biztype: this.$const.IMG_BIZTYPE.REGISTER,
                verifycode: val
            });
            if (res.code === "0") {
                /* 倒计时 */
                this.time = res.data.sendperiod;
                this.locked = true;
                this.$util.btnDisabled(this);
            } else {
                this.$message({
                    type: "warning",
                    message: res.msg
                });
            }
        },
        /* 确认密码校验 */
        confirm(rule, value, callback) {
            if (
                this.ruleForm.pwd !== this.ruleForm.confirmPwd &&
                this.ruleForm.pwd !== "" &&
                this.ruleForm.confirmPwd !== ""
            ) {
                callback(new Error("输入密码和确认密码不一致"));
            } else {
                callback();
            }
        },
        /* 密码显示或隐藏处理 */
        pwdTypeChange() {
            this.pwdType = this.pwdType === "text" ? "password" : "text";
            this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
        },
        /* 提交表单数据 */
        mobileCheck() {
            if (this.time > 0) return;
            this.$util.validateMobile("", this.ruleForm.mobile, async (err) => {
                if (!err) {
                    try {
                        // 中台未开启校验图形验证码
                        if (this.$cache.getSysParam("10103010") == "2") {
                            this.getVerifyCode("1");
                        } else {
                            this.dialogVisible = true;
                        }
                    } catch (e) {
                        this.$log.error(e);
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: err.message
                    });
                }
            });
        },
        /* 提交表单数据 */
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!this.locked) {
                        this.$message({
                            type: "warning",
                            message: "请先发送手机短信验证码"
                        });
                        return false;
                    }
                    if (!this.checkbox && this.protocol.length > 0) {
                        let tip = "";
                        for (let key of this.protocol) {
                            tip += `《${key.title}》`;
                        }
                        this.$message({
                            type: "warning",
                            message: `您还没有签署 ${tip}`
                        });
                        return false;
                    }
                    this.register();
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 注册 */
        async register() {
            var newCountry = "";
            if (this.ruleForm.country == "中国+86") {
                newCountry = "86";
            } else {
                newCountry = this.ruleForm.country;
            }
            const res = await userApi.login({
                logintype: "06",
                loginsystemtype: conf.systemtype,
                smscode: this.ruleForm.verifyCode,
                mobileno: this.ruleForm.mobile,
                invtp: "1",
                registerpwd: this.$util.enc(this.ruleForm.pwd)
            });
            if (res.error) return;
            const { data } = res;
            this.$cache.setBinded(data.others.isbind === "1");
            this.$cache.setHeadImage(data.others.headimage ? data.others.headimage : "");

            if (this.protocol.length > 0) {
                let _data = [];
                for (const key of this.protocol) {
                    _data.push({
                        policyid: key.id,
                        policytype: key.policytype || "",
                        policyversion: key.policyversion || ""
                    });
                }
                const resp = await userApi.addPolicyLog({
                    policyList: JSON.stringify(_data)
                });
                if (resp.error) return;
            }
            this.$store
                .dispatch("login", {
                    key: this.ruleForm.mobile,
                    ...JSON.parse(sessionStorage.getItem("_a") || "{}"),
                    userinfo: data.others,
                    userName: data.userName
                })
                .then(() => {
                    this.registerVisible = true;
                })
                .catch((e) => {
                    console.log("login error", e);
                });
        },
        /* 返回登录页 */
        returnLogin(flag) {
            if (flag === "1") {
                this.$router.go(-1);
                return false;
            }
            this.$router.push("/");
        },
        validateMobile(rule, value, callback) {
            if (this.ruleForm.country == "中国+86" || this.ruleForm.country == "86") {
                this.$util.validateMobile(rule, value, callback);
            }
        },
        getAgreement() {
            this.$util.getProtocol(this.agrType).then((res) => {
                this.protocol = res;
            });
        },
        argRead(item) {
            this.agrVisible = true;
            this.agrData = item;
        },
        checkDialogClose() {
            this.$router.replace("/home");
        },
        agrVisibleHdie() {
            this.agrVisible = false;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
:deep(#app) {
    background-color: #fff !important;
}
.bizcomp-border,
.bizcomp-border-none {
    box-shadow: none;
}
.bizcomp-register {
    margin-bottom: 20px;
    .register-lead {
        color: $text-color1;
        font-size: $f18;
        text-align: center;
        line-height: 30px;
        padding: 18px 0 28px 0;
        &:hover {
            color: $color-a;
        }
    }
    .el-row.register {
        padding-top: 99px;
        margin-bottom: 80px;
        .el-form-item {
            &.is-required .el-form-item__label:before {
                content: "";
            }
            .select {
                width: 130px;
            }
            .el-form-item__label {
                font-size: $f16;
                color: $text-color2;
            }
            .el-input {
                font-size: $f16;
                width: 400px;
                .get-verify {
                    color: $bg18;
                    margin-right: 18px;
                    cursor: pointer;
                }
                .get-verify-disabled {
                    color: $text-color3;
                    cursor: not-allowed;
                    margin-right: 18px;
                }
                .fa {
                    margin-right: 6px;
                }
            }
            .get-verify {
                color: $color-b-o;
                min-width: 100px;
                width: 100%;
            }
            .el-button {
                width: 180px;
                border-radius: 2px;
            }
            .el-button + .el-button {
                margin-left: 40px;
            }
            .el-form-item__error--inline {
                color: $color-c;
            }
        }
        .mobile-row ::v-deep .el-form-item__error.el-form-item__error--inline {
            position: absolute;
            left: 402px;
            top: 50%;
            transform: translateY(-50%);
        }
        .el-form-item.check {
            margin-bottom: 10px;
            .el-checkbox-group {
                height: 40px;
            }
            .el-form-item__error--inline {
                display: block;
            }
        }
        .el-input__inner {
            border-radius: 2px;
        }
        .protocol {
            margin-bottom: 10px;
        }
        .privacy-agreement {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            color: #999;
            .grey {
                margin-left: 4px;
            }
            .el-checkbox__inner {
                width: 10px;
            }
            .red {
                color: $bg18;
                cursor: pointer;
            }
        }
    }

    .el-row.register-result {
        text-align: center;
        padding-top: 35px;
        .had-trade {
            margin-bottom: 20px;
            display: inline-block;
        }
        .register-other {
            padding-bottom: 29px;
            .register-btn-msg {
                color: $text-color1;
                line-height: 30px;
                padding: 19px 0 17px;
                display: block;
            }
            .register-other-box {
                .other-list {
                    margin: 0 20px 0 15px;
                    display: inline-block;
                    .other-list-img {
                        vertical-align: middle;
                    }
                    .other-list-text {
                        color: $text-color3;
                        margin-left: 10px;
                    }
                }
            }
        }
    }

    .register-success {
        .register-msg {
            border-radius: 6px;
            background: #f9f9f9;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            margin: 40px 20px;
            padding: 40px 20px;
            .msg1 {
                font-family: Source Han Sans CN, sans-serif;
                font-size: 26px;
                font-weight: 500;
                margin: 23.83px 0 16px;
                color: $text-color2;
            }
            .red {
                color: #e60012;
            }
        }
        .dialog-footer {
            margin-bottom: 30px;
            .el-button {
                width: 180px;
                height: 42px;
                border-radius: 2px;
            }
            .fund-list {
                background: #005bad;
                border-color: #005bad;
                margin-right: 40px;
            }

            img {
                width: 18px;
                height: 12px;
                margin-left: 4px;
            }
        }
    }
    .protocol-detail {
        padding: 20px 10px;
        max-height: 60vh;
        min-height: 10vh;
        overflow: scroll;
    }
    :deep(.el-checkbox .el-checkbox__inner) {
        width: 18px;
        height: 18px;
    }
    :deep(.el-checkbox .el-checkbox__inner:after) {
        border-width: 2px;
        left: 4px;
        height: 8px;
        width: 4px;
    }
    :deep(input.el-input__inner) {
        font-size: 16px;
    }
}
</style>
